import SEO from "components/SEO";
import Hero from "sections/home/hero";
import AboutConclase from "ui/about-conclase";
import Footer from "ui/footer";
import Industries from "ui/industries";
import LetsBuild from "ui/lets-build";
import Stacstart from "ui/stacstart";
import TrustedBy from "ui/trusted-by";
import WhatWeDo from "ui/what-we-do";
import WhyConclase from "ui/why-conclase";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://conclaseint.com/#webpage",
  "url": "https://conclaseint.com/",
  "name": "Conclase: Tech Recruiting | Tech Training | Tech Start-up Studio",
  "description": "Conclase builds Africa's technology workforce and delivery capacity. Hire pre-vetted tech talent in 24–48 hours, launch software projects, manage your tech operations, or upskill your team.",
  "isPartOf": { "@id": "https://conclaseint.com/#website" },
  "about": { "@id": "https://conclaseint.com/#organization" },
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://conclaseint.com/" }
    ]
  }
};

const HomePage = () => {
  return (
    <>
      <SEO
        title="Tech Talent Recruitment, IT Outsourcing & Project Delivery | Conclase"
        description="Conclase builds Africa's technology workforce and delivery capacity. Hire pre-vetted tech talent in 24–48 hours, launch software projects, manage your tech operations, or upskill your team."
        url="https://conclaseint.com/"
        keywords="tech talent recruitment Nigeria, IT outsourcing Africa, software development company Nigeria, managed technology services, corporate tech training, project delivery Africa, Conclase"
        jsonLd={homeJsonLd}
      />
      <Hero />
      <AboutConclase />
      <WhatWeDo />
      <Stacstart />
      <WhyConclase />
      <Industries />
      <TrustedBy />

      {/* <Partners /> */}

      <LetsBuild />
      <Footer />
    </>
  );
};

export default HomePage;
